export const CHART_LP_INTERVAL = {
  DAY: (24 * 60 * 60) / 10,
  WEEK: (7 * 24 * 60 * 60) / 10,
  MONTH: (30 * 24 * 60 * 60) / 10,
  YEAR: (365 * 24 * 60 * 60) / 10,
};

export const CHART_TOKEN_COLORS: Record<string, string> = {
  SOL: "#e6194b", 
  BTC: "#3cb44b", 
  ETH: "#4363d8", 
  TRY: "#984ea3", 
  DOGE: "#a65628",  
  "1000PEPE": "#46f0f0"
};